import { Component, OnInit, input } from "@angular/core";

@Component({
  selector: "av-expansion-panel",
  templateUrl: "./expansion-panel.component.html",
  styleUrls: ["./expansion-panel.component.scss"],
  standalone: false,
})
export class ExpansionPanelComponent implements OnInit {
  readonly title = input<string>(undefined);

  isOpen = false;

  constructor() {}

  ngOnInit(): void {}
}
